/* ===== Подключение компонентов React ===== */
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

/* ===== Подключение Стилей ===== */
import styles from "./Nav.module.scss";

function NavLevel({ items = [], level = 0, onNavigate, resetToken }) {
  const [openId, setOpenId] = useState(null);

  // ✅ Сброс состояния при закрытии меню
  useEffect(() => {
    setOpenId(null);
  }, [resetToken]);

  const toggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  const handleLinkClick = (e) => {
    e.stopPropagation(); // чтобы клик по тексту не раскрывал
    onNavigate?.();      // закрыть бургер + reset
  };

  return (
    <ul className={level === 0 ? styles.list : styles.subList}>
      {items.map((item) => {
        const hasChildren = item.children?.length > 0;
        const isOpen = openId === item.id;
        const isHash = typeof item.href === "string" && item.href.startsWith("#");

        return (
          <li
            key={item.id}
            className={level === 0 ? styles.item : styles.subItem}
          >
            <div
              className={`${styles.row} ${hasChildren ? styles.hasChildren : ""}`}
              onClick={() => hasChildren && toggle(item.id)}
              role={hasChildren ? "button" : undefined}
              tabIndex={hasChildren ? 0 : undefined}
              aria-expanded={hasChildren ? isOpen : undefined}
              onKeyDown={(e) => {
                if (!hasChildren) return;
                if (e.key === "Enter" || e.key === " ") toggle(item.id);
              }}
            >
              {/* ===== Ссылка ===== */}
              {isHash ? (
                <a
                  href={item.href}
                  className={styles.link}
                  onClick={handleLinkClick}
                >
                  {item.label}
                </a>
              ) : (
                <NavLink
                  to={item.href}
                  end={item.href === "/"}
                  className={({ isActive }) =>
                    `${level === 0 ? styles.link : styles.subLink} ${
                      isActive ? styles.activeLink : ""
                    }`
                  }
                  onClick={handleLinkClick}
                >
                  {item.label}
                </NavLink>
              )}

              {/* ===== Стрелка ===== */}
              {hasChildren && (
                <span
                  className={`${styles.chevron} ${
                    isOpen ? styles.chevronOpen : ""
                  }`}
                />
              )}
            </div>

            {/* ===== Дочерние ===== */}
            {hasChildren && (
              <div
                className={`${styles.sub} ${
                  isOpen ? styles.subOpen : ""
                }`}
              >
                <NavLevel
                  items={item.children}
                  level={level + 1}
                  onNavigate={onNavigate}
                  resetToken={resetToken}
                />
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
}

export default NavLevel;
